import React, { createContext, useContext, useState } from 'react';

type DropStatus = {
  page: boolean;
  row: boolean;
  element: boolean;
};

export const DropContext = createContext({ page: false, row: false, element: false });
export const DropUpdateContext = createContext((status: DropStatus) => status);

export function useDropContext() {
  return useContext(DropContext);
}

export function useDropUpdateContext() {
  return useContext(DropUpdateContext);
}

export function DropProvider({ children }: { children: string | JSX.Element | JSX.Element[] }) {
  const [status, setStatus] = useState<DropStatus>({ page: false, row: false, element: false });

  function toogleStatus(status: DropStatus) {
    setStatus(status);
    return status;
  }

  return (
    <DropContext.Provider value={status}>
      <DropUpdateContext.Provider value={toogleStatus}>{children}</DropUpdateContext.Provider>
    </DropContext.Provider>
  );
}
